import { render, staticRenderFns } from "./BatchUploadStaff.vue?vue&type=template&id=e4f8d1e4"
import script from "./BatchUploadStaff.vue?vue&type=script&lang=js"
export * from "./BatchUploadStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports